<div style="position: relative">
	@if (chartData.timeSeries?.length) {
		<div>
			<chart-graph
				(deletePoint)="deleteDataPoint($event)"
				(editPoint)="savEditedDataPointChanges($event)"
				[chartSettings]="chartData.settings"
				[timeSeriesData]="chartData.timeSeries"
				[uniqueIdForRoot]="chartData.pk"
			/>
			<asset-chart-settings
				(settingsChanged)="saveNewSettings($event)"
				[settings]="chartData"
			></asset-chart-settings>
		</div>
	}

	@if (!chartData.timeSeries?.length) {
		<div>
			<au-empty-placeholder
				(buttonClicked)="openAddValue.emit()"
				[buttonText]="'add_data_point' | translate"
				[description]="'add_data_points_description' | translate"
				iconName="add"
				placeholderPath="assets/img/no-graph.svg"
			></au-empty-placeholder>
		</div>
	}
</div>
